<div *ngIf="performanceModel?.accountProfile">
    <table style=  "width: 100%">
        <tr class="historical-volatility-header" aria-label="Historical volitility measure">
            <th scope="col" style="text-align:left">Fund options</th>
            <th scope="col"></th>
            </tr>
            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Dividend Reinvestment</td>
                <td scope="col">{{performanceModel?.accountProfile?.divReinvest | DashIfEmpty }}</td>
               
            </tr>
            <tr class="historical-volatility">
                <td scope="col" style="text-align:left">Dollar Cost Averaging</td>
                <td scope="col">{{performanceModel?.accountProfile?.dollarCostAveraging | DashIfEmpty}}</td>
            </tr>
            </table>
</div>
<div *ngIf="!performanceModel?.accountProfile">
    <p class="rps-paragraph-one">Fund options</p>
    <p class="rps-paragraph-one">This information is temporarily unavailable.</p>
</div>